import React from "react";
import { Form, Checkbox, Button, Typography } from "antd";

const { Title } = Typography;
const videoURL =
  "https://firebasestorage.googleapis.com/v0/b/operataxis.firebasestorage.app/o/driver%2Fsmartmove%20go%20features_0.mp4?alt=media&token=bbe0bcdb-f16c-424a-bc20-49cfc5790d78";

const Step17 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => next())
      .catch((errorInfo) => console.log("Validation Failed:", errorInfo));
  };

  return (
    <Form form={form} layout="vertical" style={{ maxWidth: 800, margin: "0 auto" }}>
      <Title level={2}>SmartMove Go Features</Title>

      {/* Video Player */}
      <div style={{ height: "500px", border: "1px solid #ccc", marginBottom: "20px" }}>
        <video
          src={videoURL}
          width="100%"
          height="100%"
          style={{ borderRadius: "10px" }}
          controls
          autoPlay
          muted 
        />
      </div>

      <Form.Item
        name="smartMoveFeatures"
        valuePropName="checked"
        rules={[{ required: true, message: "Please confirm you have watched the SmartMove Features video." }]}
      >
        <Checkbox  onChange={(e) => {
      form.setFieldsValue({
        smartMoveFeatures: e.target.checked ? "agree" : undefined,
      });
    }}>I have watched the SmartMove Go Features video.</Checkbox>
      </Form.Item>

      <Form.Item style={{ textAlign: "center" }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step17;
